// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { InstrumentUtils } from "../../Utils/Instruments/InstrumentUtils.js";
import { MathUtils } from "../../Utils/MathUtils.js";
import { OperationType } from "../../Utils/Trading/OperationType.ts";
import { MarkupFormula } from "./CrossratesPlan.js";
;
export let ProfitCalculator = function (positon)
{
    this.Position = positon;
    this.IsBuy = positon.BuySell === OperationType.Buy;//islong
    this.NetPL = 0;
    this.AccNetPL = 0;
    this.AccGrossPL = 0;
    this.NetGrossPL = 0;
}

//Long position P/L = Qty * Lot size * Cross price * (Current price  - Open price) 
//Short position P/L = Qty * Lot size * Cross price * (Open price  - Current price) 

ProfitCalculator.prototype.Calculate = function ()
{
    //Type 1
    if (isNaN(this.Position.CurPriceClose))
    {
        //TODO  Костылище!!!!!!!!!!!!!
        let last = this.Position.Instrument.Level1.GetLastPrice(this.Position.Account);
        if (!isNaN(last) && last !== this.Position.CurPriceClose)
        {
            this.Position.CurPriceClose = last;
            this.Position.lastPriceUpdated = true;
        }
    }

    // this.AccNetPL = this.CalculateAccNetPLByQty(this.Position.Amount)

    // let crossInstrumentUSD = DataCache.CrossRateCache.GetCrossPriceExp1(this.Position.Account.assetBalanceDefault.Asset.Name);

    // this.NetPL = this.AccNetPL * crossInstrumentUSD;

    // this.AccGrossPL = this.AccNetPL;
    // this.NetGrossPL = this.AccNetPL * crossInstrumentUSD;   // #87945

    // this.AccNetPL += this.Position.Swaps - this.Position.Commission;    // #88118

    let result = ProfitCalculator.GetPnLByPosition(this.Position)
    this.AccNetPL = result.netProfitAcc
    this.NetPL = result.netProfitUSD
    this.AccGrossPL = result.profitAcc
    this.NetGrossPL = result.profitUSD
}

ProfitCalculator.prototype.CalculateAccNetPLByQty = function (Qty)
{
    return ProfitCalculator.GetGrossPLByPositionAndCustomQuantity(this.Position, Qty)

    // let result = 0;
    // let Ins = this.Position.Instrument;
    // let asset = this.Position.Account.assetBalanceDefault.Asset;

    // let crossAccountUSD = DataCache.CrossRateCache.GetCrossPriceExp1Exp2(Ins.Exp2, asset.Name);

    // // let crossInstrumentUSD = DataCache.CrossRateCache.GetCrossPriceIns(Ins);
    // //let CrossPrice = crossInstrumentUSD;
    // let CrossPrice = crossAccountUSD;

    // let PriceDif = this.IsBuy ? (this.Position.CurPriceClose - this.Position.OpenPrice) : (this.Position.OpenPrice - this.Position.CurPriceClose);

    // let LotSize = Ins.LotSize;

    // //Type 2
    // if (Ins.QuotingType === QuotingType.TickCost_TickSize)
    //     LotSize = Ins.FuturesTickCoast > 0 ? Ins.FuturesTickCoast / Ins.GetPipsSize(Ins.PointSize) : 1;

    // result = Qty * LotSize * CrossPrice * PriceDif;

    // if (this.Position.Account.RiskPlan !== null)
    // {
    //     let rps = this.Position.Account.RiskPlan.riskPlanCache.getRiskPlanSettings(this.Position.Instrument, this.Position.ProductType, "UseSameCrossPriceForOpenClose")

    //     if (!rps.getValue(this.Position.ProductType, "UseSameCrossPriceForOpenClose"))
    //     {
    //         let CP = this.Position.CurPriceClose * CrossPrice;
    //         let OP = this.Position.OpenPrice * this.Position.OpenCrossPrice;
    //         let dif = this.IsBuy ? (CP - OP) : (OP - CP);
    //         result = Qty * LotSize * dif;
    //     }
    // }

    // result = MathUtils.TruncateDouble(result, 8)  // fucking math in JS #97625 + lost accuracy #105907

    // return result;
}

ProfitCalculator.CalculateSLTP = function (Qty, CurPriceClose, OpenPrice, ins, account, isBuy, CrossPrice, OpenCrossPrice, orderObject)
{
    let result = 0;
    let UseSameCrossPriceForOpenClose = true
    let hasPT = !!orderObject && orderObject.isPosition && orderObject.ProductType !== undefined && orderObject.ProductType !== null;
    if (account.RiskPlan !== null && hasPT)
    {
        let rps = account.RiskPlan.riskPlanCache.getRiskPlanSettings(ins, orderObject.ProductType, "UseSameCrossPriceForOpenClose")
        UseSameCrossPriceForOpenClose = rps.getValue(orderObject.ProductType, "UseSameCrossPriceForOpenClose");
    }

    let side = OperationType[isBuy ? 'Buy' : 'Sell'],
        productType = hasPT ? orderObject.ProductType : null
    let pnl = ProfitCalculator.GetPnL(new ProfitInputParams(ins, account, side, Qty, OpenPrice, OpenCrossPrice, CurPriceClose, null, null, productType))

    return pnl.profitAcc;

    // let CustomCrossPrice = hasPT && !UseSameCrossPriceForOpenClose ? OpenCrossPrice : CrossPrice;

    // let LotSize = ins.LotSize;

    // //Type 2
    // if (ins.QuotingType === QuotingType.TickCost_TickSize)
    //     LotSize = ins.FuturesTickCoast > 0 ? ins.FuturesTickCoast / ins.GetPipsSize(ins.PointSize) : 1;

    // let CP = CurPriceClose * CrossPrice;
    // let OP = OpenPrice * CustomCrossPrice;
    // let dif = isBuy ? (CP - OP) : (OP - CP);
    // result = Qty * LotSize * dif;

    // return result
}
//Long position P/L = Qty * Lot size * (Current price * Current cross price - Open price * Open cross price)
//Short position P/L = Qty * Lot size * (Open price * Open cross price - Current price * Current cross price) 

ProfitCalculator.GetUnitVolume = function (amount, lotSize)
{
    return amount * lotSize
}
ProfitCalculator.GetAmountExp1 = function (side, amount, lotSize)
{
    return ProfitCalculator.GetUnitVolume(amount, lotSize) * (side == OperationType.Buy ? 1 : -1)
}
ProfitCalculator.GetAmountExp1ByPosition = function (pos)
{
    return ProfitCalculator.GetAmountExp1(pos.BuySell, pos.Amount, pos.Instrument.LotSize)
}
ProfitCalculator.GetAmountExp1Close = function (pos)
{
    return -ProfitCalculator.GetAmountExp1(pos)
}

ProfitCalculator.GetAmountExp2Close = function (ins, side, qty, closePrice) 
{
    let roundClosePrice = ins ? ins.roundPrice(closePrice) : closePrice,
        lotSize = ins ? ins.LotSize : 1;
    return ProfitCalculator.GetAmountExp1(side, qty, lotSize) * roundClosePrice;
}
ProfitCalculator.GetAmountExp2CloseByPosition = function (pos)
{
    return ProfitCalculator.GetAmountExp2Close(pos.Instrument, pos.BuySell, pos.Amount, MathUtils.ProcessNaN(pos.CurPriceClose))
}

ProfitCalculator.GetAmountExp2Open = function (side, qty, lotSize, openPrice) 
{
    let roundOpenPrice = MathUtils.TruncateDouble(openPrice, InstrumentUtils.MAX_PRECISION_ON_SERVER)
    return -ProfitCalculator.GetAmountExp1(side, qty, lotSize) * roundOpenPrice;
}
ProfitCalculator.GetAmountExp2OpenByPosition = function (pos)
{
    return ProfitCalculator.GetAmountExp2Open(pos.BuySell, pos.Amount, pos.Instrument.LotSize, position.Price)
}


ProfitCalculator.GetPnL = function (inputParams)
{
    let account = inputParams.Account,
        instrument = inputParams.Instrument,
        dataCache = instrument.DataCache,
        productType = inputParams.ProductType,
        side = inputParams.Side,
        crossInstrumentAccDouble = dataCache.CrossRateCache.GetCrossPriceExp1Exp2(instrument.Exp2, account.BaseCurrency),
        crossInstrumentAccDecimal = crossInstrumentAccDouble,
        openCrossPriceDecimal = inputParams.OpenCrossPrice,
        crossAccountUSD = dataCache.CrossRateCache.GetCrossPriceExp1(account.BaseCurrency),
        crossInstrumentUSD = dataCache.CrossRateCache.GetCrossPriceIns(instrument),
        ticCost = instrument.GetTickCost(),
        amount = inputParams.Amount;

    let lotSize = instrument ? instrument.LotSize : 1;
    let amountExp2OpenDecimal = ProfitCalculator.GetAmountExp2Open(side, amount, lotSize, inputParams.OpenPrice);
    let amountExp2CloseDecimal = ProfitCalculator.GetAmountExp2Close(instrument, side, amount, inputParams.ClosePrice);

    let markupObj = account.CrossratesPlan && instrument ? account.CrossratesPlan.GetMarkup(instrument.Exp2, account.BaseCurrency, crossInstrumentAccDouble, instrument, side == OperationType.Buy) : { 'markup': 0, 'formula': MarkupFormula.None };
    let markupInstrumentAcc = markupObj.markup;
    let formula = markupObj.formula

    let profitUSD, profitAcc;
    let netProfitUSD, netProfitAcc;

    let rps = account.RiskPlan.riskPlanCache.getRiskPlanSettings(instrument, productType, "UseSameCrossPriceForOpenClose")
    let UseSameCrossPriceForOpenClose = rps.getValue(productType, "UseSameCrossPriceForOpenClose")

    if (UseSameCrossPriceForOpenClose || openCrossPriceDecimal == 0)
    {
        //профит в серверной валюте, без маркапа (разница цен * кросс)
        profitUSD = ((amountExp2OpenDecimal + amountExp2CloseDecimal) * crossInstrumentUSD * ticCost);

        if (formula == MarkupFormula.OpenAndClose)
        {
            //1я формула, маркап применяется к обоим кроссам открытия и закрытия
            profitAcc = ((amountExp2OpenDecimal * (crossInstrumentAccDecimal + markupInstrumentAcc) + amountExp2CloseDecimal * (crossInstrumentAccDecimal - markupInstrumentAcc)) * ticCost);
        }
        else if (formula == MarkupFormula.Pnl || formula == MarkupFormula.MarginOpenAndClose)
        {
            //знак перед маркапом определяется знаком текущего пнл
            let pnl = amountExp2OpenDecimal + amountExp2CloseDecimal;
            profitAcc = (pnl * (crossInstrumentAccDecimal - Math.sign(pnl) * Math.abs(markupInstrumentAcc)) * ticCost);
        }
        else
        {
            //без маркапа (разница цен * кросс)
            profitAcc = (amountExp2OpenDecimal + amountExp2CloseDecimal) * crossInstrumentAccDecimal * ticCost;
        }
    }
    else
    {
        //профит в серверной валюте, без маркапа (открыте*кросс1 + закрыте*кросс2 )
        profitUSD = (amountExp2OpenDecimal * openCrossPriceDecimal * crossAccountUSD + amountExp2CloseDecimal * crossInstrumentUSD) * ticCost;

        if (formula == MarkupFormula.OpenAndClose)
        {
            //маркапим кросс закрытия, открытие уже сервер промаркапил
            profitAcc = (amountExp2OpenDecimal * openCrossPriceDecimal + amountExp2CloseDecimal * (crossInstrumentAccDecimal - markupInstrumentAcc)) * ticCost;
        }
        else
        {
            //для всех других случаев - без маркапа
            profitAcc = (amountExp2OpenDecimal * openCrossPriceDecimal + amountExp2CloseDecimal * crossInstrumentAccDecimal) * ticCost;
        }
    }

    //профит (как положительный так и отрицательный) - это базис
    //если комиссия положительна, это деньги, которые СНИМУТСЯ со счета (если отриц. - добавятся) потому "-комиссия"
    //свопы наоборот, положителен, если наутро деньги будут прибавлены, поэтому "+своп"
    let swaps = inputParams.Swaps || 0;
    let commissions = inputParams.Commissions || 0;
    // if (swaps && commissions)
    // {
    netProfitUSD = profitUSD + ((swaps - commissions) * crossAccountUSD);
    netProfitAcc = profitAcc + (swaps - commissions);
    // }
    // else
    //     netProfitUSD = netProfitAcc = null;

    return { 'profitUSD': profitUSD, 'profitAcc': profitAcc, 'netProfitUSD': netProfitUSD, 'netProfitAcc': netProfitAcc };
}

ProfitCalculator.GetPnLByPosition = function (position)
{
    return ProfitCalculator.GetPnL(ProfitInputParams.CreateFromPosition(position))
}

ProfitCalculator.GetGrossPLByPositionAndCustomQuantity = function (position, qty)
{
    let inputParams = ProfitInputParams.CreateFromPosition(position)
    inputParams.Amount = qty

    let pnlFull = ProfitCalculator.GetPnL(inputParams)

    return pnlFull.profitAcc
}

export let ProfitInputParams = function (instrument, account, side, amount, openPrice, openCrossPrice, closePrice, swaps, commissions, productType)
{
    this.Instrument = instrument;
    this.Account = account;
    this.Side = side;
    this.Amount = amount;
    this.OpenPrice = openPrice;
    this.OpenCrossPrice = openCrossPrice;
    this.ClosePrice = closePrice;
    this.Swaps = swaps;
    this.Commissions = commissions;
    this.ProductType = productType;
}

ProfitInputParams.CreateFromPosition = function (pos)
{
    return new ProfitInputParams(pos.Instrument, pos.Account, pos.BuySell, pos.Amount, pos.Price, pos.OpenCrossPrice, pos.CurPriceCloseNotRounded, pos.Swaps, pos.Commission, pos.ProductType)
}